webpackJsonp([35783957827783],{

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SeattleByBikeTourLeaderColin = __webpack_require__(450);
	
	var _SeattleByBikeTourLeaderColin2 = _interopRequireDefault(_SeattleByBikeTourLeaderColin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    "div",
	    { className: "w-5/6 max-w-xl ml-auto mr-auto bg-brand-white my-8 px-6 py-8 mx-auto", id: "about", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	    _react2.default.createElement(
	      "div",
	      { className: "flex items-center justify-center mx-auto" },
	      _react2.default.createElement("img", { src: _SeattleByBikeTourLeaderColin2.default, className: "rounded w-full", alt: "Photo showing the Tour Guide Leader Colin leading a bike tour at the Ballard Locks." })
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "font-bold mt-8 mb-2 font-title" },
	      "About Seattle By Bike"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "leading-normal font-body" },
	      "Seattle by Bike is a partnership of local bike enthusiasts with skills in various areas - education, graphic design, and web development. Our goal is to create a simple, enjoyable, experience of seeing Seattle at the speed of a bike ride. We think it is the best way to learn about and appreciate our city!"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "flex items-center justify-center py-8" },
	      _react2.default.createElement(
	        "button",
	        { className: "flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-500 fb-entity-config-id- fb-domain-go.theflybook.com fb-protocol-https rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide" },
	        "Book Now"
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _question = __webpack_require__(456);
	
	var _question2 = _interopRequireDefault(_question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FAQ = function FAQ() {
	  return _react2.default.createElement(
	    "div",
	    { className: "bg-heropattern py-16", id: "faq" },
	    _react2.default.createElement(
	      "div",
	      { className: "w-5/6 max-w-xl mx-auto", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	      _react2.default.createElement(
	        "div",
	        { className: "font-bold font-title flex items-center justify-center py-8" },
	        _react2.default.createElement(
	          "svg",
	          { className: "fill-current text-grey-darkest h-4 mr-2 inline", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	          _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm2-13c0 .28-.21.8-.42 1L10 9.58c-.57.58-1 1.6-1 2.42v1h2v-1c0-.29.21-.8.42-1L13 9.42c.57-.58 1-1.6 1-2.42a4 4 0 1 0-8 0h2a2 2 0 1 1 4 0zm-3 8v2h2v-2H9z" })
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title text-xl" },
	          "Frequently Asked Questions"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "font-bold font-title" },
	            "Do I need my own bicycle?"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "Nope! All tours include a knowledgeable guide, quality bicycle, and helmet."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "This looks fun, can we book you for company events, wedding parties, group outings, etc?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "Sure! We welcome groups of all sizes and kinds. Lets chat over ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:info@seattlebybike.com", className: "text-grey-darkest hover:text-brand-orange" },
	            "email"
	          ),
	          "."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "What sizes are your bikes?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "We are partnered with ",
	          _react2.default.createElement(
	            "a",
	            { href: "http://www.recycledcycles.com", target: "_blank", className: "text-grey-darkest hover:text-brand-orange" },
	            "Recycled Cycles"
	          ),
	          ", a local bike shop that has been around since 1994. They provide us with a wide range of bike sizes and can accommodate guests from 4\u201910\u201D to 6\u20199\u201D in height."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "How difficult are the bike tours?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "Both the Emerald City Tour and Lake Union Loop have stops built in every 5-10 minutes and both are relatively flat with a few gentle hills. These tours are accessible to anyone comfortable on a bicycle and comfortable being active, with breaks included, over the course of three hours. The Lake Washington Scenic Ride is meant for folks who ride regularly. Road bikes are included for this tour. It has stops built in every 15-20 minutes and is flat for two thirds of the ride and hilly for one third. The total elevation gain/loss is 1082 feet."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "Can I bring my own bike?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "Yes! You can bring your own bike. There is a discount of $20 if you bring your own bike. Bike helmets are required, though, so bring your helmet or rent one at our meeting location Recycled Cycles for $5."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "Okay, so what about a ride sharing bike (Lime, Ofo, etc)?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "You can rent and bring a share bike like LimeBike or Ofo and get the BYOB discount, but they are not recommended for our tours. We tried them out and think they are too heavy and too often not working properly."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "What is your cancellation policy?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "We have a 24 hour Full Refund Policy. You can cancel or change your reservation any time up to 24 hours before your tour start time. Inside of 24 hours from the start of your tour, there are no refunds, exchanges, or exceptions."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "px-6 py-4" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-bold font-title" },
	          "Where do we meet?"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-base font-body leading-normal" },
	          "We will meet at Recycled Cycles ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://goo.gl/maps/8XcU6wEHMAL2", target: "_blank", className: "text-grey-darkest hover:text-brand-orange" },
	            "(1007 NE Boat St, Seattle, WA 98105)"
	          ),
	          ", which is located in between the neighborhoods of Fremont and Wallingford, on the north shore of Lake Union in Seattle. There is limited free parking in the neighborhood around Recycled Cycles. There is also a paid parking lot directly across the street, and ridesharing (Uber, Lyft, etc) are always a good option in Seattle."
	        )
	      )
	    )
	  );
	};
	
	exports.default = FAQ;
	module.exports = exports["default"];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noun_68012Spaceneedle = __webpack_require__(453);
	
	var _noun_68012Spaceneedle2 = _interopRequireDefault(_noun_68012Spaceneedle);
	
	var _noun_755386Waterfront = __webpack_require__(454);
	
	var _noun_755386Waterfront2 = _interopRequireDefault(_noun_755386Waterfront);
	
	var _noun_1360677Boat = __webpack_require__(452);
	
	var _noun_1360677Boat2 = _interopRequireDefault(_noun_1360677Boat);
	
	var _noun_945817Sphere = __webpack_require__(455);
	
	var _noun_945817Sphere2 = _interopRequireDefault(_noun_945817Sphere);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Features = function Features() {
	  return _react2.default.createElement(
	    "div",
	    { className: "bg-brand-blue py-16 " },
	    _react2.default.createElement(
	      "div",
	      { className: "w-5/6 max-w-xl mx-auto", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	      _react2.default.createElement(
	        "h3",
	        { className: "text-center text-brand-white w-3/4 py-2 mx-auto leading-normal font-bold font-title text-xl py-6" },
	        "Our tours feature local attractions:"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "flex flex-row flex-wrap items-center justify-around text-center max-w-xl mx-auto p-4 md:p-8 text-sm" },
	        _react2.default.createElement(
	          "div",
	          { className: "p-4" },
	          _react2.default.createElement("img", { className: "fill-current text-blue h-24", src: _noun_68012Spaceneedle2.default, alt: "An icon for The Space Needle" }),
	          _react2.default.createElement(
	            "p",
	            { className: "text-brand-white text-lg text-center mt-2" },
	            "Space Needle"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "p-4" },
	          _react2.default.createElement("img", { className: "fill-current text-blue h-24 ", src: _noun_945817Sphere2.default, alt: "An icon representing The Amazon Spheres at HQ1" }),
	          _react2.default.createElement(
	            "p",
	            { className: "text-brand-white text-lg text-center mt-2" },
	            "Amazon Spheres"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "p-4" },
	          _react2.default.createElement("img", { className: "fill-current text-blue h-24", src: _noun_1360677Boat2.default, alt: "A Boat icon to represent the Ballard Locks" }),
	          _react2.default.createElement(
	            "p",
	            { className: "text-brand-white text-lg text-center mt-2" },
	            "Ballard Locks"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "p-4" },
	          _react2.default.createElement("img", { className: "fill-current text-blue h-24", src: _noun_755386Waterfront2.default, alt: "An icon representing the Seattle Waterfront" }),
	          _react2.default.createElement(
	            "p",
	            { className: "text-brand-white text-lg text-center mt-2" },
	            "Seattle Waterfront"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Features;
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quotes = function Quotes() {
	    return _react2.default.createElement(
	        "section",
	        { className: "bg-grey-lightest py-8" },
	        _react2.default.createElement(
	            "div",
	            { className: "w-5/6 max-w-xl ml-auto mr-auto" },
	            _react2.default.createElement(
	                "div",
	                { className: "flex flex-wrap" },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "text-center font-bold text-base w-full py-8 mx-auto leading-normal font-title" },
	                        "Seattle by Bike offers guided bicycle tours that make memories and explore the best sights and sounds of the Emerald City. But don't just take our word for it..."
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "w-full lg:w-1/3 px-6 py-6", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "bg-brand-blue hover:bg-blue rounded shadow-lg overflow-hidden p-8 leading-normal" },
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-brand-white mb-4 font-title font-bold" },
	                                "\"I really enjoyed my tour on Seattle By Bike. Even as a local, I learned a bunch of new fun historical facts about my city! Totally recommended!\""
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-brand-white leading-tight font-body text-base" },
	                                "- Janae L."
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "w-full lg:w-1/3 px-6 py-6", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "bg-brand-blue hover:bg-blue rounded shadow-lg overflow-hidden p-8 leading-normal" },
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-brand-white mb-4 font-title font-bold" },
	                                "\"Seattle by Bike was the perfect way to see the city! All the major sights, in just a few hours. The route was just as promised- mostly flat, with a few hills. I loved the tour!\""
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-brand-white leading-tight font-body text-base" },
	                                "- Yelena A."
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "w-full lg:w-1/3 px-6 py-6", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "bg-brand-blue hover:bg-blue rounded shadow-lg overflow-hidden p-8 leading-normal" },
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-brand-white mb-4 font-title font-bold" },
	                                "\"Great sites! Great stories! Seattle by Bike was an excellent way to see the city and learn Seattle's history at the same time. I had a lot of fun on the tour.\""
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-brand-white leading-tight font-body text-base" },
	                                "- Britt A."
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Quotes;
	module.exports = exports["default"];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Lake_Union_Loop_thumbnail = __webpack_require__(448);
	
	var _Lake_Union_Loop_thumbnail2 = _interopRequireDefault(_Lake_Union_Loop_thumbnail);
	
	var _Emerald_City_Tour_thumbnail = __webpack_require__(446);
	
	var _Emerald_City_Tour_thumbnail2 = _interopRequireDefault(_Emerald_City_Tour_thumbnail);
	
	var _IMG_ = __webpack_require__(447);
	
	var _IMG_2 = _interopRequireDefault(_IMG_);
	
	var _time = __webpack_require__(457);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tours = function Tours() {
	  return _react2.default.createElement(
	    "div",
	    { className: "bg-brand-white flex justify-around py-8", id: "tours" },
	    _react2.default.createElement(
	      "div",
	      { className: "w-5/6 max-w-2xl ml-auto mr-auto my-8", "data-aos": "fade", "data-aos-duration": "1200", "data-aos-delay": "300", "data-aos-once": "true" },
	      _react2.default.createElement(
	        "div",
	        { className: "flex flex-row justify-center flex-wrap" },
	        _react2.default.createElement(
	          "div",
	          { className: "max-w-xs m-2 rounded flex-auto overflow-hidden shadow-lg flex flex-col" },
	          _react2.default.createElement("img", { className: "w-full flex-grow", src: _Lake_Union_Loop_thumbnail2.default, alt: "A photo of the Lake Union tour showing the view of South Lake Union from Gasworks Park. " }),
	          _react2.default.createElement(
	            "div",
	            { className: "px-6 py-4 flex-grow" },
	            _react2.default.createElement(
	              "div",
	              { className: "font-bold text-xl mb-2 uppercase font-title" },
	              "Lake Union Loop"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "text-grey-darker text-base leading-normal font-body pt-4 pr-4 pb-4" },
	              "Circumnavigate beautiful Lake Union! Located inside Seattle\u2019s city limits at the north end of downtown, Lake Union is at the heart of Seattle\u2019s history and culture. This tour explores the distinctive lakeside neighborhoods and pauses along the way to sample local craft coffee, chocolate, and beer."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "p-8 bg-grey-lightest flex-grow" },
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "Difficulty: ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "text-green font-bold" },
	                  "Easy"
	                ),
	                " to ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "text-orange font-bold" },
	                  "Moderate"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "Start Time: ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-bold" },
	                  "11AM"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M0 0l20 8-8 4-2 8z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "70% Bike Path"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M2 14v-3H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1l4-7h8l4 7h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm13.86-5L13 4H7L4.14 9h11.72zM5.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "30% City Streets"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "About 7 miles"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M16.32 7.1A8 8 0 1 1 9 4.06V2h2v2.06c1.46.18 2.8.76 3.9 1.62l1.46-1.46 1.42 1.42-1.46 1.45zM10 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM7 0h6v2H7V0zm5.12 8.46l1.42 1.42L10 13.4 8.59 12l3.53-3.54z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "About 3 hours"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  { className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "$65 per person"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex items-center justify-center text-center pt-8 pb-6" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "button",
	                  { className: "rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed", disabled: true },
	                  "Closed until 2025"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "max-w-xs m-2 rounded flex-auto overflow-hidden shadow-lg flex flex-col mt-2" },
	          _react2.default.createElement("img", { className: "w-full flex-grow", src: _Emerald_City_Tour_thumbnail2.default, alt: "A photo of the Emerald City tour which features iconic landmarks like The Space Needle, Amazon HQ1 and the Ballard locks" }),
	          _react2.default.createElement(
	            "div",
	            { className: "px-6 py-4 flex-grow" },
	            _react2.default.createElement(
	              "div",
	              { className: "font-bold text-xl mb-2 uppercase font-title" },
	              "Emerald City Tour"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "text-grey-darker text-base leading-normal font-body pt-4 pr-4 pb-4" },
	              "Want to get to know the city? This tour packs in iconic landmarks, history, and culture with frequent stops for stories and fantastic views, at spots like The Space Needle and Amazon HQ1. See and hear what makes Seattle one of the fastest growing and most well loved destinations in the United States!"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "p-8 bg-grey-lightest flex-grow" },
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "Difficulty: ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "text-orange font-bold" },
	                  "Moderate"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "Start Time: ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-bold" },
	                  "11AM"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M0 0l20 8-8 4-2 8z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "80% Bike Path"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M2 14v-3H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1l4-7h8l4 7h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm13.86-5L13 4H7L4.14 9h11.72zM5.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "20% City Streets"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "About 15 miles"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M16.32 7.1A8 8 0 1 1 9 4.06V2h2v2.06c1.46.18 2.8.76 3.9 1.62l1.46-1.46 1.42 1.42-1.46 1.45zM10 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM7 0h6v2H7V0zm5.12 8.46l1.42 1.42L10 13.4 8.59 12l3.53-3.54z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "About 3.5 hours"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    className: "fill-current text-grey h-3 self-center",
	                    xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "$70 per person"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex items-center justify-center text-center  pt-8 pb-6" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "button",
	                  { className: "rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed", disabled: true },
	                  "Closed until 2025"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "max-w-xs m-2 rounded flex-auto overflow-hidden shadow-lg flex flex-col mt-2" },
	          _react2.default.createElement("img", { className: "w-full flex-grow", src: _IMG_2.default, alt: "A photo of the bike tour on trail through trees." }),
	          _react2.default.createElement(
	            "div",
	            { className: "px-6 py-4 flex-grow" },
	            _react2.default.createElement(
	              "div",
	              { className: "font-bold text-xl mb-2 uppercase font-title" },
	              "Lake Washington Scenic Ride"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "text-grey-darker text-base leading-normal font-body pt-4 pr-4 pb-4" },
	              "Want to get some miles in? This 40 mile route showcases the natural beauty of Lake Washington\u2019s north end. Your knowledgeable guide not only keeps you on route, but points out landmarks and shares stories of the Pacific Northwest\u2019s natural and cultural history along the way!"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "p-8 bg-grey-lightest flex-grow" },
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "Difficulty: ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "text-orange font-bold" },
	                  "Moderate"
	                ),
	                " to ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "text-red font-bold" },
	                  "Challenging"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "Start Time: ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-bold" },
	                  "11AM"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M0 0l20 8-8 4-2 8z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "90% Bike Path"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "svg",
	                {
	                  className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                  viewBox: "0 0 20 20" },
	                _react2.default.createElement("path", { d: "M2 14v-3H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1l4-7h8l4 7h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm13.86-5L13 4H7L4.14 9h11.72zM5.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" })
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "font-body text-base ml-2" },
	                "10% City Streets"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "About 40 miles"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    className: "fill-current text-grey h-3 self-center", xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M16.32 7.1A8 8 0 1 1 9 4.06V2h2v2.06c1.46.18 2.8.76 3.9 1.62l1.46-1.46 1.42 1.42-1.46 1.45zM10 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM7 0h6v2H7V0zm5.12 8.46l1.42 1.42L10 13.4 8.59 12l3.53-3.54z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "About 4.5 hours"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex pb-2" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    className: "fill-current text-grey h-3 self-center",
	                    xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 20 20" },
	                  _react2.default.createElement("path", { d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z" })
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "font-body text-base ml-2" },
	                  "$80 per person"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "flex items-center justify-center text-center  pt-8 pb-6" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "button",
	                  { className: "rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed", disabled: true },
	                  "Closed until 2025"
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	// import mapSVG from "./../../images/map.svg";
	exports.default = Tours;
	module.exports = exports["default"];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Emerald_City_Tour_thumbnail.954527e5.jpg";

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_6683.616a0494.jpg";

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Lake_Union_Loop_thumbnail.a678e031.jpg";

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SeattleByBike-TourLeaderColin.4b1bed4b.jpg";

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDI2cHgiIGhlaWdodD0iNDE3cHgiIHZpZXdCb3g9IjAgMCA0MjYgNDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MC4yICg1NTA0NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+bm91bl8xMzYwNjc3LWJvYXQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0ibm91bl8xMzYwNjc3LWJvYXQiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMTguNiw0NS43MTEgTDIxOC42LDAuNTI2IEwyMDcuMDk3LDAuNTI2IEwyMDcuMDk3LDQ1LjcxMSBMOTIuNzIzLDQ1LjcxMSBMOTIuNzIzLDYzLjk3NSBMMTE1LjgyMyw2My45NzUgTDExNS44MjMsMTkwLjM0OCBMMTE5LjU3NywxOTAuMzQ4IEMxNjMuNjQyLDE2NS42NDUgMjE0LjE4MSwxNDkuNDExIDIxNC4xODEsMTQ5LjQxMSBDMjE0LjE4MSwxNDkuNDExIDI2NC4yNDUsMTY1LjQ5IDMwOC4xNjIsMTg5Ljk5NSBMMzA4LjE2Miw2My45NzUgTDMzMS4yNTksNjMuOTc1IEwzMzEuMjU5LDQ1LjcxMSBMMjE4LjYsNDUuNzExIFogTTE3NS4zNjksMTI1LjE2MSBMMTMxLjk0LDEyNS4xNjEgTDEzMS45NCw3MS42NjEgTDE3NS4zNjksNzEuNjYxIEwxNzUuMzY5LDEyNS4xNjEgWiBNMjM0LjU2MiwxMjUuMTYxIEwxOTEuMTM1LDEyNS4xNjEgTDE5MS4xMzUsNzEuNjYxIEwyMzQuNTYyLDcxLjY2MSBMMjM0LjU2MiwxMjUuMTYxIFogTTI5My43NTcsMTI1LjE2MSBMMjUwLjMyOCwxMjUuMTYxIEwyNTAuMzI4LDcxLjY2MSBMMjkzLjc1Nyw3MS42NjEgTDI5My43NTcsMTI1LjE2MSBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3Ny4wMDAwMDAsIDE2Ni4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMjguODU3LDEuMzE1IEM5OS40MjEsMTEuNzMyIDEuODExLDQ5LjQ1MyAwLjY3Myw5Mi4wOTEgQzAuNDYsOTkuNzg0IDYuNTg2LDExNS43OTkgMTQuMDYsMTMyLjI1NCBDMjguNjkyLDEzNS43MjggMzguMTk5LDEzNC40ODUgNTYuMjk3LDEyOC40ODIgQzc4LjYxMywxMjEuMTIyIDg2LjA0NywxMjEuMTIyIDEwOC4zNjIsMTI4LjQ4MiBDMTE2LjUzNywxMzEuMTk1IDEyMi45MzYsMTMyLjkyIDEyOC44NTcsMTMzLjY5OSBMMTI4Ljg1NywxLjMxNSBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNDMuMDIyLDAuNDQzIEwxNDMuMDIyLDEzMy42NzUgQzE0OC45NDMsMTMyLjg4OSAxNTUuMzk1LDEzMS4xNzEgMTYzLjY0NywxMjguNDgxIEMxODUuNjI3LDEyMS4zNjkgMTkyLjI2NCwxMjAuODczIDIxNS43MTcsMTI4LjQ4MSBDMjM1LjA4NywxMzQuODE4IDI0NC42NjQsMTM1Ljg1NSAyNjAuNTkxLDEzMS42MjcgQzI2Ny45MzUsMTE1LjM5MyAyNzMuOTA1LDk5LjY4NyAyNzMuNjk1LDkyLjA5MSBDMjcyLjUyMSw0OC4xNzEgMTY4Ljk2LDkuNDU4IDE0My4wMjIsMC40NDMgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPHBhdGggZD0iTTQwMC4wMzMsMzc1LjY3NyBDMzc3Ljc0MiwzNjguMzE3IDM3MC4yNjMsMzY4LjMxNyAzNDcuOTk4LDM3NS42NzcgQzMyNS4wNjYsMzgzLjI4NiAzMTUuOTU1LDM4My4yODYgMjkyLjcxOCwzNzUuNjc3IEMyNjkuMjY1LDM2OC4wNzMgMjYyLjYyOCwzNjguNTY3IDI0MC42NDgsMzc1LjY3NyBDMjE3LjMxMSwzODMuMjg2IDIwOC4yNzksMzgzLjI4NiAxODUuMzYyLDM3NS42NzcgQzE2My4wNDcsMzY4LjMxNyAxNTUuNjEzLDM2OC4zMTcgMTMzLjI5NywzNzUuNjc3IEMxMTAuMzczLDM4My4yODYgMTAxLjI2OSwzODMuMjg2IDc4LjAxNywzNzUuNjc3IEM2Ni42OTEsMzcxLjk5OCA1Ny44NDUsMzcwLjExNyA1MS43MTksMzcwLjExNyBDNDUuOTQ4LDM3MC4xMTcgMzcuMjg3LDM3MS45OTggMjUuOTM3LDM3NS42NzcgQzE1LjM3MSwzNzkuMTQ2IDYuOTM3LDM4MC44MjQgMC4zMjYsMzgxLjE0OCBMMC4zMjYsNDE1LjQxOCBMMC40MTEsNDE2Ljc3NSBDNC4zMjMsNDE0LjY0MyAxMy4xNDQsNDEyLjc2OCAyNC41MDUsNDA5LjA4NiBDNDguMzg5LDQwMS4yNzkgNTYuODg5LDQwMS43MTMgNzkuNDkzLDQwOS4wODYgQzEwMS41Miw0MTYuMjMgMTA4LjIxMyw0MTYuNzI4IDEzMS41OCw0MDkuMDg2IEMxNTQuNzkyLDQwMS40NzggMTYzLjc4NCw0MDEuNDc4IDE4Ny4xNDEsNDA5LjA4NiBDMjEwLjQ4Myw0MTYuNjk1IDIxNy4xNjYsNDE2LjIzIDIzOS4yMzEsNDA5LjA4NiBDMjYxLjc4Nyw0MDEuNjQ2IDI3MC4yMzcsNDAxLjI1MiAyOTQuMTk2LDQwOS4wODYgQzMxNi4xMTEsNDE2LjIzIDMyMi44MTMsNDE2LjY5NSAzNDYuMjgxLDQwOS4wODYgQzM2OS41MjgsNDAxLjQ3OCAzNzguNjMsNDAxLjQ3OCA0MDEuNTUyLDQwOS4wODYgQzQxMS4zOTUsNDEyLjM2NSA0MTkuMzg0LDQxNC4xODQgNDI1LjM3NSw0MTQuNTYyIEw0MjUuNTU4LDM4MS4xODYgQzQyMC41MSwzODEuODc2IDQxMS40ODMsMzc5LjQ5OSA0MDAuMDMzLDM3NS42NzcgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00MDAuMDMzLDMxNy44MDQgQzM3Ny43NDIsMzEwLjQ0NiAzNzAuMjYzLDMxMC40NDYgMzQ3Ljk5OCwzMTcuODA0IEMzMjUuMDY2LDMyNS40MTMgMzE1Ljk1NSwzMjUuNDEzIDI5Mi43MTgsMzE3LjgwNCBDMjY5LjI2NSwzMTAuMTk2IDI2Mi42MjgsMzEwLjY5NCAyNDAuNjQ4LDMxNy44MDQgQzIxNy4zMTEsMzI1LjQxMyAyMDguMjc5LDMyNS40MTMgMTg1LjM2MiwzMTcuODA0IEMxNjMuMDQ3LDMxMC40NDYgMTU1LjYxMywzMTAuNDQ2IDEzMy4yOTcsMzE3LjgwNCBDMTEwLjM3MywzMjUuNDEzIDEwMS4yNjksMzI1LjQxMyA3OC4wMTcsMzE3LjgwNCBDNjYuNjkxLDMxNC4xMjUgNTcuODQ1LDMxMi4yNDQgNTEuNzE5LDMxMi4yNDQgQzQ1Ljk0OCwzMTIuMjQ0IDM3LjI4NywzMTQuMTI1IDI1LjkzNywzMTcuODA0IEMxNS4zNzEsMzIxLjI3NCA2LjkzNywzMjIuOTUxIDAuMzI2LDMyMy4yNzUgTDAuMzI2LDM1Ny41NDUgTDAuNDExLDM1OC45MDIgQzQuMzIzLDM1Ni43NzEgMTMuMTQ0LDM1NC44OTUgMjQuNTA1LDM1MS4yMTUgQzQ4LjM4OSwzNDMuNDA2IDU2Ljg4OSwzNDMuODM5IDc5LjQ5MywzNTEuMjE1IEMxMDEuNTIsMzU4LjM1OSAxMDguMjEzLDM1OC44NTQgMTMxLjU4LDM1MS4yMTUgQzE1NC43OTIsMzQzLjYwOSAxNjMuNzg0LDM0My42MDkgMTg3LjE0MSwzNTEuMjE1IEMyMTAuNDgzLDM1OC44MTkgMjE3LjE2NiwzNTguMzU5IDIzOS4yMzEsMzUxLjIxNSBDMjYxLjc4NywzNDMuNzcyIDI3MC4yMzcsMzQzLjM3OCAyOTQuMTk2LDM1MS4yMTUgQzMxNi4xMTEsMzU4LjM1OSAzMjIuODEzLDM1OC44MTkgMzQ2LjI4MSwzNTEuMjE1IEMzNjkuNTI4LDM0My42MDkgMzc4LjYzLDM0My42MDkgNDAxLjU1MiwzNTEuMjE1IEM0MTEuMzk1LDM1NC40OTMgNDE5LjM4NCwzNTYuMzEgNDI1LjM3NSwzNTYuNjkzIEw0MjUuMzc1LDMyNC4xMjIgQzQxOS43ODksMzI0LjEyMSA0MTEuNDgzLDMyMS42MjQgNDAwLjAzMywzMTcuODA0IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTZweCIgaGVpZ2h0PSI5NnB4IiB2aWV3Qm94PSIwIDAgNTYgOTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5TbGljZSAxPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Im5vdW5fNjgwMTItc3BhY2VuZWVkbGUiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00OCw0Mi45NiBMOCw0Mi45NiBDNi45LDQyLjk2IDYsNDIuMDY0IDYsNDAuOTYgTDYsMjAuOTYgQzYsMTkuODU2IDYuOSwxOC45NiA4LDE4Ljk2IEw0OCwxOC45NiBDNDkuMSwxOC45NiA1MCwxOS44NTYgNTAsMjAuOTYgTDUwLDQwLjk2IEM1MCw0Mi4wNjQgNDkuMSw0Mi45NiA0OCw0Mi45NiBaIE0xMCwzOC45NiBMNDYsMzguOTYgTDQ2LDIyLjk2IEwxMCwyMi45NiBMMTAsMzguOTYgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik01NCwzMC45NiBMMiwzMC45NiBDMC45LDMwLjk2IDAsMzAuMDY0IDAsMjguOTYgQzAsMjcuODU2IDAuOSwyNi45NiAyLDI2Ljk2IEw1NCwyNi45NiBDNTUuMSwyNi45NiA1NiwyNy44NTYgNTYsMjguOTYgQzU2LDMwLjA2NCA1NS4xLDMwLjk2IDU0LDMwLjk2IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNMzYsMjIuOTYgTDIwLDIyLjk2IEMxOC45LDIyLjk2IDE4LDIyLjA2NCAxOCwyMC45NiBMMTgsMTIuOTYgQzE4LDExLjg1NiAxOC45LDEwLjk2IDIwLDEwLjk2IEwzNiwxMC45NiBDMzcuMSwxMC45NiAzOCwxMS44NTYgMzgsMTIuOTYgTDM4LDIwLjk2IEMzOCwyMi4wNjQgMzcuMSwyMi45NiAzNiwyMi45NiBaIE0yMiwxOC45NiBMMzQsMTguOTYgTDM0LDE0Ljk2IEwyMiwxNC45NiBMMjIsMTguOTYgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yOCwxMi45NiBDMjYuOSwxMi45NiAyNiwxMi4wNjQgMjYsMTAuOTYgTDI2LDIuOTYgQzI2LDEuODU2IDI2LjksMC45NiAyOCwwLjk2IEMyOS4xLDAuOTYgMzAsMS44NTYgMzAsMi45NiBMMzAsMTAuOTYgQzMwLDEyLjA2NCAyOS4xLDEyLjk2IDI4LDEyLjk2IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNNDIuOTcyLDk1LjA0IEM0Mi4xOTIsOTUuMDQgNDEuNDQ0LDk0LjU4IDQxLjEyOCw5My44MiBDMzUuMTI4LDc5LjU0IDMzLjg5Niw0OC41NzIgMzMuODk2LDQxLjA1NiBDMzMuODk2LDM5Ljk1MiAzNC43OTYsMzkuMDU2IDM1Ljg5NiwzOS4wNTYgQzM2Ljk5NiwzOS4wNTYgMzcuODk2LDM5Ljk1MiAzNy44OTYsNDEuMDU2IEMzNy44OTYsNTEuOTQ0IDM5LjY0NCw3OS45NTYgNDQuODEyLDkyLjI2NCBDNDUuMjMyLDkzLjI4OCA0NC43NTYsOTQuNDUyIDQzLjczMiw5NC44OCBDNDMuNDk2LDk0Ljk4OCA0My4yMzYsOTUuMDQgNDIuOTcyLDk1LjA0IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNMTEuOTA4LDk1LjA0IEMxMS42NTYsOTUuMDQgMTEuMzg0LDk0Ljk4OCAxMS4xNCw5NC44ODQgQzEwLjExMiw5NC40NiA5LjY0LDkzLjI5MiAxMC4wNjQsOTIuMjY4IEMxNS4yMzYsNzkuOTYgMTYuOTgsNTEuOTQ4IDE2Ljk4LDQxLjA2IEMxNi45OCwzOS45NTYgMTcuODc2LDM5LjA2IDE4Ljk4LDM5LjA2IEMyMC4wNzYsMzkuMDYgMjAuOTgsMzkuOTU2IDIwLjk4LDQxLjA2IEMyMC45OCw0OC41NzYgMTkuNzQ4LDc5LjU0IDEzLjc0OCw5My44MiBDMTMuNDIsOTQuNTggMTIuNjg0LDk1LjA0IDExLjkwOCw5NS4wNCBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/noun_755386-waterfront.26abdc58.svg";

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/noun_945817-sphere.cef67c16.svg";

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTEwIDIwYTEwIDEwIDAgMSAxIDAtMjAgMTAgMTAgMCAwIDEgMCAyMHptMi0xM2MwIC4yOC0uMjEuOC0uNDIgMUwxMCA5LjU4Yy0uNTcuNTgtMSAxLjYtMSAyLjQydjFoMnYtMWMwLS4yOS4yMS0uOC40Mi0xTDEzIDkuNDJjLjU3LS41OCAxLTEuNiAxLTIuNDJhNCA0IDAgMSAwLTggMGgyYTIgMiAwIDEgMSA0IDB6bS0zIDh2Mmgydi0ySDl6Ii8+PC9zdmc+"

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTEwIDIwYTEwIDEwIDAgMSAxIDAtMjAgMTAgMTAgMCAwIDEgMCAyMHptMC0yYTggOCAwIDEgMCAwLTE2IDggOCAwIDAgMCAwIDE2em0tMS03LjU5VjRoMnY1LjU5bDMuOTUgMy45NS0xLjQxIDEuNDFMOSAxMC40MXoiLz48L3N2Zz4="

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quotes = __webpack_require__(199);
	
	var _Quotes2 = _interopRequireDefault(_Quotes);
	
	var _Features = __webpack_require__(196);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Tours = __webpack_require__(200);
	
	var _Tours2 = _interopRequireDefault(_Tours);
	
	var _FAQ = __webpack_require__(195);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _About = __webpack_require__(194);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Quotes2.default, null),
	    _react2.default.createElement(_Features2.default, null),
	    _react2.default.createElement(_Tours2.default, null),
	    _react2.default.createElement(_FAQ2.default, null),
	    _react2.default.createElement(_About2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ebbfd9e9b3132d3b2342.js